let savedMetatags;
export default function findMetatag(tagName) {
    if (!savedMetatags) {
        savedMetatags = getMetatags();
    }
    return savedMetatags[tagName];
}
export function getMetatags() {
    /* eslint-disable-next-line no-restricted-globals */
    const tags = Array.from(window.document.getElementsByTagName('meta'));
    const result = {};
    for (const tag of tags) {
        result[tag.name] = tag.content;
    }
    return result;
}
export function overrideGetMetatags(newMetatags) {
    savedMetatags = newMetatags;
}
